export default __webpack_public_path__ + "0813a8bda448758e686bffb07c62c4b3.jpg";